export function CoffeeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7.832 4.555a1 1 0 00-1.664-1.11l-.63.946a2 2 0 000 2.218l.63.946a1 1 0 101.664-1.11l-.63-.945.63-.945z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 11a2 2 0 012-2h10a2 2 0 011.732 1h.314a2.954 2.954 0 011.639 5.412l-2.13 1.42a.996.996 0 01-.198.102A7.001 7.001 0 014 14v-3zm2 0h10v3a5 5 0 01-10 0v-3zm12.046 1H18v2l-.001.132.576-.384a.954.954 0 00-.53-1.748z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M11.555 3.168a1 1 0 01.277 1.387l-.63.945.63.945a1 1 0 01-1.664 1.11l-.63-.946a2 2 0 010-2.218l.63-.946a1 1 0 011.387-.277zM15.832 4.555a1 1 0 00-1.664-1.11l-.63.946a2 2 0 000 2.218l.63.946a1 1 0 001.664-1.11l-.63-.945.63-.945z"
      ></path>
    </svg>
  );
}
